import { actionTypes } from 'redux-resource'
import { apiCall } from '../api'
import { AppDispatch } from '../store'
import { snakeCaseToCamelCase } from '../utils/snakeCaseToCamelCase'
import { camelCaseToSnakeCase } from '../utils/camelCaseToSnakeCase'

export const updateResource = <T extends { id: number }>(args: {
  path: string
  type: string
  resource: T
  params: object
}) => (dispatch: AppDispatch) => {
  const { path, type, resource, params } = args

  dispatch({
    type: actionTypes.UPDATE_RESOURCES_PENDING,
    resourceType: type,
    resources: [resource.id]
  })

  return apiCall
    .request({
      method: 'patch',
      url: path,
      data: camelCaseToSnakeCase(params)
    })
    .then((response) => {
      dispatch({
        type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
        resourceType: type,
        resources: [snakeCaseToCamelCase(response.data)]
      })
    })
    .catch(() => {
      dispatch({
        type: actionTypes.UPDATE_RESOURCES_FAILED,
        resourceType: type,
        resources: resource.id
      })
    })
}
